/** `artha.bidha` — aligned with backend Artha entity. */
export const ARTHA_BIDHA = [
  'itihas',
  'puran',
  'jyotish',
  'dharmasastra',
  'darshan',
] as const;
